import { Payments } from './../models/payments';
import { HttpClient, HttpHeaders, HttpErrorResponse,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PagosGeneralesService {

  private api = environment.api+'/api/';


  constructor(
    private http: HttpClient
  ) { }

  getPagos(dateStart?, dateEnd?,companyId?) : Observable<Payments>{
    return this.http.post<any>(this.api + 'servicesPayments/historyPaysGenerals', {
      dateStart: dateStart,
      dateEnd: dateEnd,
      companyId: companyId
    }).pipe(catchError(this.errorMgmt));
  }

  getPagosTae(dateStart?, dateEnd?, companyId?) : Observable<Payments>{
    return this.http.post<any>(this.api + 'servicesPayments/historyPaysGeneralsTae', {
      dateStart: dateStart,
      dateEnd: dateEnd,
      companyId: companyId
    }).pipe(catchError(this.errorMgmt));
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

}
